export interface Testimonial {
  id: number;
  name: string;
  username: string;
  avatar: string;
  content: string;
  rating: number;
}

export const testimonials: Testimonial[] = [
  {
    id: 1,
    name: "Kamil Nowak",
    username: "@kamil_zakupy",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20European%20man%20with%20short%20styled%20dark%20hair%20and%20genuine%20friendly%20smile%20warm%20natural%20studio%20lighting%20on%20soft%20sage%20green%20background%20clean%20modern%20portrait%20photography%20with%20natural%20skin%20tones%20and%20gentle%20catchlights%20in%20eyes&width=120&height=120&seq=avatar-v2-kamil&orientation=squarish",
    content: "Kakobuy Spreadsheet to absolutny game-changer! Dzięki niemu znalazłem tyle świetnych produktów, że nie nadążam z zamawianiem. Polecam każdemu, kto chce oszczędzić czas na szukaniu.",
    rating: 5,
  },
  {
    id: 2,
    name: "Aleksandra Wiśniewska",
    username: "@ola_fashion",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20European%20woman%20with%20wavy%20blonde%20hair%20and%20warm%20confident%20smile%20soft%20natural%20window%20lighting%20on%20warm%20terracotta%20background%20modern%20portrait%20photography%20with%20gentle%20shadows%20and%20natural%20skin%20tones&width=120&height=120&seq=avatar-v2-ola&orientation=squarish",
    content: "Używam Kakobuy Spreadsheet od 3 miesięcy i jestem zachwycona. Katalog jest zawsze aktualny, a poradniki bezpieczeństwa dały mi pewność przy pierwszych zamówieniach. Super sprawa!",
    rating: 5,
  },
  {
    id: 3,
    name: "Michał Kowalczyk",
    username: "@michal_deals",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20European%20man%20with%20light%20brown%20hair%20and%20relaxed%20confident%20expression%20soft%20warm%20studio%20lighting%20on%20dusty%20rose%20background%20modern%20casual%20portrait%20photography%20with%20natural%20catchlights&width=120&height=120&seq=avatar-v2-michal&orientation=squarish",
    content: "Najlepszy spreadsheet na rynku! Porównywałem z innymi i ten jest najbardziej przejrzysty. Kategorie są świetnie posegregowane, wszystko pod ręką. Oszczędza mnóstwo czasu.",
    rating: 5,
  },
  {
    id: 4,
    name: "Natalia Mazur",
    username: "@natka_shopping",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20European%20woman%20with%20dark%20curly%20hair%20and%20bright%20genuine%20smile%20soft%20diffused%20natural%20lighting%20on%20warm%20peach%20background%20modern%20casual%20portrait%20photography%20with%20lively%20expression&width=120&height=120&seq=avatar-v2-natalia&orientation=squarish",
    content: "Dopiero zaczynałam z Kakobuy i bałam się pierwszego zamówienia. Dzięki poradnikom i spreadsheetowi wszystko poszło gładko. Teraz zamawiam regularnie i polecam znajomym!",
    rating: 4,
  },
  {
    id: 5,
    name: "Tomasz Zieliński",
    username: "@tomek_reseller",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20European%20man%20with%20styled%20hair%20and%20approachable%20confident%20smile%20warm%20studio%20lighting%20on%20soft%20mint%20background%20modern%20business%20casual%20portrait%20photography%20with%20clean%20composition&width=120&height=120&seq=avatar-v2-tomasz&orientation=squarish",
    content: "Prowadzę mały biznes i Kakobuy Spreadsheet to moje tajne źródło produktów. Aktualizacje codziennie to coś, czego nie oferuje żadna inna platforma. Polecam każdemu resellerowi!",
    rating: 5,
  },
  {
    id: 6,
    name: "Karolina Adamczyk",
    username: "@karola_style",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20European%20woman%20with%20short%20stylish%20pixie%20haircut%20and%20genuine%20warm%20smile%20soft%20natural%20lighting%20on%20soft%20coral%20background%20elegant%20modern%20portrait%20photography%20with%20clean%20minimal%20aesthetic&width=120&height=120&seq=avatar-v2-karolina&orientation=squarish",
    content: "Kocham to, jak łatwo znaleźć produkty w Kakobuy Spreadsheet. Poradnik bezpieczeństwa był dla mnie kluczowy - teraz wiem, jak unikać oszustw i bezpiecznie kupować. Warto!",
    rating: 5,
  },
];